import { EVENT_LEVELS } from "./index";
export var defaultSupportedListeners = {
    "android": { enabled: true, eventLevels: [EVENT_LEVELS.INFO] },
    "flutter": { enabled: true, eventLevels: [EVENT_LEVELS.INFO] },
    "iframe": { enabled: true, eventLevels: [EVENT_LEVELS.INFO], targetOrigin: "*" },
    "ios": { enabled: true, eventLevels: [EVENT_LEVELS.INFO] },
    "react-native": { enabled: true, eventLevels: [EVENT_LEVELS.INFO] },
};
//# sourceMappingURL=Constants.js.map